import { useProductPageStore } from '../../contexts/ProductPageStore'

import AdditionalFacetDrawer from 'Clutch/Organisms/AdditionalFacetDrawer/newAdditionalFacetDrawer'

const AdditionalFacetDrawerWrapper = () => {
  const fitment = useProductPageStore((x) => x.fitment)
  const checkFitment = useProductPageStore((x) => x.checkFitment)
  const skuBaseNumber = useProductPageStore((x) => x.skuBaseNumber)
  const skuVariantNumber = useProductPageStore((x) => x.skuVariantNumber)

  return (
    <AdditionalFacetDrawer
      fitment={fitment}
      checkFitment={checkFitment}
      skuBaseNumber={skuBaseNumber}
      skuVariantNumber={skuVariantNumber}
    />
  )
}

export default AdditionalFacetDrawerWrapper
